"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyHmac = void 0;
const jssha_1 = __importDefault(require("jssha"));
const helpers_1 = require("./helpers");
class AirwebTicketLegacyHmac {
    constructor(key = null, separator, algorithm, encoding) {
        this.key = key;
        this.separator = separator;
        this.algorithm = algorithm;
        this.encoding = encoding;
    }
    implodeObjectValues(object) {
        const stringValues = Object.values(object).map((value) => {
            if ((0, helpers_1.isObject)(value)) {
                if (Object.keys(value).length < 1)
                    return null;
                return this.implodeObjectValues(value);
            }
            if ((0, helpers_1.isArray)(value) && value.length) {
                return this.implodeObjectValues(value);
            }
            if (value === false)
                return '';
            if (value === true)
                return '1';
            return value;
        });
        return stringValues.join(this.separator);
    }
    sortObjectByKey(input) {
        return Object.keys(input)
            .sort()
            .reduce((output, key) => {
            let value = input[key];
            if (typeof value === 'string' && AirwebTicketLegacyHmac.jsonRegExp.test(value)) {
                const decoded = JSON.parse(value);
                if (decoded) {
                    value = decoded;
                }
            }
            output[key] = (0, helpers_1.isObject)(value) ? this.sortObjectByKey(value) : value;
            return output;
        }, {});
    }
    static cleanupObject(input, dirt = [undefined]) {
        return Object.entries(input).reduce((output, [key, value]) => {
            if (dirt.includes(value))
                return output;
            output[key] = value;
            if ((0, helpers_1.isObject)(value))
                output[key] = this.cleanupObject(value, dirt);
            return output;
        }, {});
    }
    generate(data) {
        const hashSortedData = this.sortObjectByKey(data);
        const hashDataString = this.implodeObjectValues(hashSortedData);
        const hashCipher = new jssha_1.default(this.algorithm, 'TEXT', {
            hmacKey: { value: this.key, format: 'TEXT' },
        });
        hashCipher.update(hashDataString);
        const hashString = hashCipher.getHash(this.encoding);
        return hashString;
    }
}
AirwebTicketLegacyHmac.jsonRegExp = /^"?\[?{.*\}]?"?$/;
exports.AirwebTicketLegacyHmac = AirwebTicketLegacyHmac;
//# sourceMappingURL=hmac.js.map